import React, { useState } from "react";
import { Card, Table, Form, Dropdown } from "react-bootstrap";
import { FaEdit, FaTrash, FaDownload } from "react-icons/fa";
import EditAgentModal from "../../../modals/agent-modals/EditAgentModal";
import DeleteAgentModal from "../../../modals/agent-modals/DeleteAgentModal";
import { RiDeleteBin6Line } from "react-icons/ri";
// import EditAgentModal from "../components/EditAgentModal"
// import DeleteAgentModal from "../components/DeleteAgentModal"

const AgentsList = ({ agents: propsAgents, setAgents: propsSetAgents }) => {
  const initialAgents = [
    {
      id: "Agt-016",
      name: "William Parsons",
      email: "william@example.com",
      role: "Senior Support Agent",
      assigned: 30,
      resolved: 20,
      status: "Available",
      img: "/assets/img/agents/agent-01.jpg",
    },
    {
      id: "Agt-015",
      name: "Lucille Tomberlin",
      email: "lucille@example.com",
      role: "Junior Support Agent",
      assigned: 20,
      resolved: 10,
      status: "Available",
      img: "/assets/img/agents/agent-02.jpg",
    },
    {
      id: "Agt-014",
      name: "Frederick Johnson",
      email: "frederick@example.com",
      role: "Senior Support Agent",
      assigned: 10,
      resolved: 8,
      status: "Available",
      img: "/assets/img/agents/agent-03.jpg",
    },
    {
      id: "Agt-013",
      name: "Sarah Henry",
      email: "sarah@example.com",
      role: "Junior Support Agent",
      assigned: 15,
      resolved: 12,
      status: "Available",
      img: "/assets/img/agents/agent-04.jpg",
    },
    {
      id: "Agt-012",
      name: "Thomas Miller",
      email: "thomas@example.com",
      role: "Senior Support Agent",
      assigned: 25,
      resolved: 20,
      status: "Available",
      img: "/assets/img/agents/agent-05.jpg",
    },
    {
      id: "Agt-011",
      name: "Melissa Shelton",
      email: "melissa@example.com",
      role: "Junior Support Agent",
      assigned: 32,
      resolved: 30,
      status: "Available",
      img: "/assets/img/agents/agent-06.jpg",
    },
    {
      id: "Agt-010",
      name: "James Rodriguez",
      email: "james@example.com",
      role: "Senior Support Agent",
      assigned: 12,
      resolved: 10,
      status: "Available",
      img: "/assets/img/agents/agent-07.jpg",
    },
    {
      id: "Agt-009",
      name: "Regina Chavez",
      email: "regina@example.com",
      role: "Junior Support Agent",
      assigned: 8,
      resolved: 5,
      status: "Not Available",
      img: "/assets/img/agents/agent-08.jpg",
    },
  ];

  const [localAgents, setLocalAgents] = useState(initialAgents);
  const agents = propsAgents || localAgents;
  const setAgents = propsSetAgents || setLocalAgents;
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

  const [editAgent, setEditAgent] = useState(null);
  const [deleteAgent, setDeleteAgent] = useState(null);

  const filteredAgents = agents.filter(
    (a) =>
      a.name.toLowerCase().includes(search.toLowerCase()) ||
      a.role.toLowerCase().includes(search.toLowerCase()),
  );

  const displayedAgents = filteredAgents.slice(0, rows);

  const updateAgent = (updated) => {
    setAgents(agents.map((a) => (a.id === updated.id ? updated : a)));
  };

  const deleteAgentConfirm = () => {
    setAgents(agents.filter((a) => a.id !== deleteAgent.id));
    setDeleteAgent(null);
  };

  const downloadAgent = (agent) => {
    const data = `Name: ${agent.name}\nEmail:${agent.email}\nRole:${agent.role}`;
    const blob = new Blob([data], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${agent.name}.txt`;
    link.click();
  };

  return (
    <Card
      style={{ border: "1px solid #eee", backgroundColor: "rgb(255 255 255)" }}
      className="shadow-sm"
    >
      <Card.Header
        style={{ backgroundColor: "rgb(255 255 255)" }}
        className="d-flex justify-content-between flex-wrap"
      >
        <h5>Agents List</h5>

        <div className="d-flex gap-2">
          <Dropdown>
            <Dropdown.Toggle
              className="btn btn border p-2"
              size="sm"
              variant="light"
            >
              Select Status
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Available</Dropdown.Item>
              <Dropdown.Item>Not Available</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown>
            <Dropdown.Toggle
              className="btn btn border p-2"
              size="sm"
              variant="light"
            >
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Recently Added</Dropdown.Item>
              <Dropdown.Item>Ascending</Dropdown.Item>
              <Dropdown.Item>Descending</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Card.Header>

      <div className="d-flex justify-content-between p-3 flex-wrap">
        <div className="d-flex gap-2 align-items-center">
          <span>Row Per Page</span>

          <Form.Select
            style={{ width: "90px" }}
            value={rows}
            onChange={(e) => setRows(Number(e.target.value))}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </Form.Select>

          <span>Entries</span>
        </div>

        <Form.Control
          placeholder="Search"
          style={{ width: "220px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Card.Body className="p-0">
        <Table responsive hover>
          <thead className="table-light">
            <tr>
              <th>
                <Form.Check />
              </th>
              <th>Agent ID</th>
              <th>Agent Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Tickets Assigned</th>
              <th>Tickets Resolved</th>
              <th>Availability</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {displayedAgents.map((agent) => (
              <tr key={agent.id}>
                <td>
                  <Form.Check />
                </td>

                <td>{agent.id}</td>

                <td>
                  <div className="d-flex align-items-center">
                    <img
                      src={agent.img}
                      alt=""
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                    />

                    <strong>{agent.name}</strong>
                  </div>
                </td>

                <td>{agent.email}</td>

                <td>{agent.role}</td>

                <td>{agent.assigned}</td>

                <td>{agent.resolved}</td>

                <td>
                  <span
                    className={`badge ${agent.status === "Available" ? "bg-success" : "bg-danger"}`}
                  >
                    ● {agent.status}
                  </span>
                </td>

                <td>
                  <div className="d-flex gap-3">
                    {/* <FaEdit
                      style={{ cursor: "pointer" }}
                      onClick={() => setEditAgent(agent)}
                    /> */}
  <FaEdit
    style={{
      cursor: "pointer",
      color: "#666d75", // light gray
      fontSize: "14px",
    }}
  onClick={() => setEditAgent(agent)}
  />
                    {/* <FaTrash
                      style={{ cursor: "pointer" }}
                     
                    /> */}
                    
                    
  <RiDeleteBin6Line
    style={{
      cursor: "pointer",
      color: "#666d75", // even lighter gray
      fontSize: "14px",
    }}
   onClick={() => setDeleteAgent(agent)}
  />

                    {/* <FaDownload
                      style={{ cursor: "pointer" }}
                      onClick={() => downloadAgent(agent)}
                    /> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>

      {editAgent && (
        <EditAgentModal
          show={true}
          agent={editAgent}
          handleClose={() => setEditAgent(null)}
          updateAgent={updateAgent}
        />
      )}

      {deleteAgent && (
        <DeleteAgentModal
          show={true}
          handleClose={() => setDeleteAgent(null)}
          confirmDelete={deleteAgentConfirm}
        />
      )}
    </Card>
  );
};

export default AgentsList;
